import { UseMutateAsyncFunction, useMutation } from 'react-query';

import { getAPIErrorMessage } from '../../../utils/ApiErrorUtils';

import { useIbUserAccountsAPIService } from '../useIbUserAccountsAPIService';

function useGetVerifiedUserPhoneOTP(): {
  getVerifiedUserPhoneOTPAPI: UseMutateAsyncFunction<
    any,
    unknown,
    {
      phoneNumber: string;
      countryCode: string;
      clientId?: string;
      domain?: string;
    },
    unknown
  >;
  error;
  status;
} {
  const { ibUserAccountsAPIService } = useIbUserAccountsAPIService();

  const getVerifiedUserPhoneOTP = (params) => {
    const { phoneNumber, countryCode, clientId, domain } = params;

    return ibUserAccountsAPIService.sendOtpToUserWithPhoneNumber({
      phone_number: phoneNumber,
      country_code: countryCode,
      client_id: clientId,
      domain: domain
    });
  };

  const { mutateAsync, error, status } = useMutation(getVerifiedUserPhoneOTP);

  const getVerifiedUserPhoneOTPAPI = mutateAsync;

  return {
    getVerifiedUserPhoneOTPAPI,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
}

export { useGetVerifiedUserPhoneOTP };
